import { render, staticRenderFns } from "./SenderDetails.vue?vue&type=template&id=24bbda00&"
import script from "./SenderDetails.vue?vue&type=script&lang=js&"
export * from "./SenderDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports